var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService, SFUN } from './services/common.service';
import { SharedService } from './services/shared.service';
import { UsuarioService } from './services/usuario.service';
import { KeycloakService } from './services/keycloak.service';
import { Notificacion } from './model/notificacion';
import { Observable } from 'rxjs/Rx';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { LoadingService } from './common/loading/loading.service';
import { Jsonp } from '@angular/http';
import { HttpClientWrapper } from './services/httpClient';
import { environment } from './environment';
import { ServiceException } from './model/exception';
var AppComponent = AppComponent_1 = (function () {
    function AppComponent(_injector, _httpClient, _jsonp, router, idle, keepalive) {
        this._injector = _injector;
        this._httpClient = _httpClient;
        this._jsonp = _jsonp;
        this.router = router;
        this.idle = idle;
        this.keepalive = keepalive;
        this.searchValue = "";
        this.nombreUsr = "";
        this.permisoAv = false;
        this.timedOut = false;
        this.lastPing = null;
        this.configLoaded = false;
        this.usrNoAut = false;
        this.showMenu = true;
        this._keycloak = null;
        this._service = null;
        this._uservice = null;
        this.loadingService = null;
        console.debug("App New");
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.debug("App On Init");
        var allowedUrlsWithoutAuth = ['/actuacion', '/enlace-no-autorizado', '/vinculacion-rep', '/desvinculacion-rep'];
        // Verifica si la ruta actual está en la lista de rutas permitidas sin autenticación
        if (allowedUrlsWithoutAuth.some(function (url) { return window.location.pathname.indexOf(url) !== -1; })) {
            this.configLoaded = true;
            this.showMenu = false;
            return;
        }
        // download remote config properties
        if (environment['remoteConfig']) {
            var configUrl = environment['remoteConfig'].toString();
            // if "self" go to current backend
            if (configUrl.toLowerCase().indexOf("self") > -1) {
                configUrl = location.protocol + '//' + location.hostname;
                if (location.port && location.port == "3000") {
                    configUrl = configUrl + ":8280/iol-ui";
                }
                else if (location.port) {
                    configUrl = configUrl + ":" + location.port;
                }
                configUrl = configUrl + location.pathname.substring(0, location.pathname.indexOf('/', 1))
                    + "/api/env";
            }
            //console.log("remote config loading: " + configUrl);
            this._httpClient.get(configUrl).map(function (response) { return response.json(); }).subscribe(function (response) {
                if (response["remoteConfig"]) {
                    //console.log("transitive env config ...");
                    var configUrl2 = response["remoteConfig"];
                    _this._httpClient.get(configUrl2).map(function (response) { return response.json(); }).subscribe(function (response) {
                        Object.keys(response).map(function (k) {
                            environment[k] = response[k];
                        });
                        //console.log("Configs loaded from server(2) " + configUrl2);
                        // init props in SharedService
                        SharedService.setEnv(environment);
                        // continue with app rendering
                        _this.usrHabil();
                    });
                }
                else {
                    Object.keys(response).map(function (k) {
                        environment[k] = response[k];
                    });
                    //console.log("configs loaded from server " + configUrl);
                    // init props in SharedService
                    SharedService.setEnv(environment);
                    // continue with app rendering
                    _this.usrHabil();
                }
            });
        }
        else {
            this.usrHabil();
        }
    };
    AppComponent.prototype.usrHabil = function () {
        var _this = this;
        this._uservice = this._injector.get(UsuarioService);
        this._uservice.loadUserHabil(KeycloakService.getLoggedUser()).subscribe(function (data) {
            if (data) {
                _this.init();
            }
            else {
                _this.usrNoAut = true;
                _this.router.navigate(['usuario-no-autorizado']);
            }
        }, function (error) {
            var exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            alert(exc.description);
            _this.usrNoAut = true;
            _this.router.navigate(['usuario-no-autorizado']);
        });
    };
    // init services and other stuffs (after remote props loading)
    AppComponent.prototype.init = function () {
        var _this = this;
        this.setCookieFIRMADORID();
        this._keycloak = this._injector.get(KeycloakService);
        this._service = this._injector.get(CommonService);
        this._uservice = this._injector.get(UsuarioService);
        this.loadingService = this._injector.get(LoadingService);
        AppComponent_1._observable = new Observable(function (observer) { return AppComponent_1._observer = observer; }).share();
        this._service.changeEmitted$.subscribe(function (valBol) {
            _this.blockPage(valBol);
        });
        this._service.addTimeEmittedExp$.subscribe(function (time) { _this.addTimeCaptchaExp(time); });
        this._service.envioMailEmitted$.subscribe(function (cod) { _this.chequearEnvioMailCaptcha(cod); });
        this._service.addTimeEmittedAct$.subscribe(function (time) { _this.addTimeCaptchaAct(time); });
        // sets an idle timeout of 5 seconds,for testing purposes.
        this.idle.setIdle(5);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        this.idle.setTimeout(this._service.getTimeOut());
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        this.idle.onTimeout.subscribe(function () {
            alert("La sesión ha expirado debido a inactividad");
            _this.timedOut = true;
            _this.logout();
        });
        // sets the ping interval to 15 seconds
        this.keepalive.interval(15);
        this.keepalive.onPing.subscribe(function () { return _this.lastPing = new Date(); });
        this.reset();
        // }
        // ngOnInit(): void {
        this.noti = new Notificacion(0, []);
        this.captchaSolTimeExp = new Array();
        this.captchaSolTimeAct = new Array();
        this._uservice.findUsuario(KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.usuario = response;
            KeycloakService.setLoggedUser(_this.usuario);
            _this.nombreUsr = _this.usuario.nombre + " " + _this.usuario.apellido;
            _this.permisoAv = _this._service.tienePermiso(SFUN.Avisos);
            //this._jsonp.get('//api.ipify.org/?format=jsonp&callback=JSONP_CALLBACK').subscribe(response => this.ipObtenida(response));
            _this.ipObtenidaNew();
            if (AppComponent_1._observer) {
                AppComponent_1._observer.next(_this._service.isLocalData());
            }
            if (_this.usuario.codigo.toUpperCase() === "ANONIMO") {
                _this.router.navigate(['despacho']);
            }
        });
        this._service.findAvisos(KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.noti = response;
        });
        this.configLoaded = true;
        this.showMenu = true;
        this.blockPage(false);
    };
    AppComponent.prototype.ipObtenidaNew = function () {
        this._service.ipLocal = "0.0.0.0";
        this._service.addAuditoria("LOGIN").subscribe(function (response) {
            var res = response;
        });
    };
    AppComponent.prototype.ipObtenida = function (resp) {
        this._service.ipLocal = resp._body.ip;
        this._service.addAuditoria("LOGIN").subscribe(function (response) {
            var res = response;
        });
    };
    AppComponent.prototype.reset = function () {
        this.idle.watch();
        this.timedOut = false;
    };
    AppComponent.prototype.blockPage = function (val) {
        this.loadingService.toggleLoadingIndicator(val);
    };
    AppComponent.prototype.addTimeCaptchaExp = function (time) {
        this.captchaSolTimeExp.push(time);
    };
    AppComponent.prototype.addTimeCaptchaAct = function (time) {
        this.captchaSolTimeAct.push(time);
    };
    AppComponent.prototype.chequearEnvioMailCaptcha = function (cod) {
        var miliPorMin;
        var arrayFil = new Array();
        var min;
        var cantSol;
        var mensajeMail;
        var codAud;
        if (cod == 'EXP') {
            min = this._service.getMinutosExp();
            cantSol = this._service.getCantCaptchaExp();
            mensajeMail = this._service.getMsgExp();
        }
        else {
            min = this._service.getMinutosAct();
            cantSol = this._service.getCantCaptchaAct();
            mensajeMail = this._service.getMsgAct();
        }
        var miliPorMin = min * 1000 * 60;
        var tenMinBefore = new Date().getTime() - miliPorMin;
        if (cod == 'EXP') {
            arrayFil = this.captchaSolTimeExp.filter(function (num) { return num > tenMinBefore; });
            this.captchaSolTimeExp = arrayFil;
        }
        else {
            arrayFil = this.captchaSolTimeAct.filter(function (num) { return num > tenMinBefore; });
            this.captchaSolTimeAct = arrayFil;
        }
        if (arrayFil.length > cantSol) {
            arrayFil = new Array();
            if (cod == 'EXP') {
                this.captchaSolTimeExp = new Array();
            }
            else {
                this.captchaSolTimeAct = new Array();
            }
            this._service.sendMail(this._service.getAsuntoCaptcha(), mensajeMail).subscribe();
        }
    };
    AppComponent.observable = function () {
        return AppComponent_1._observable;
    };
    AppComponent.prototype.searchText = function () {
        //console.log(this.searchValue);
    };
    AppComponent.prototype.setTitulo = function (newTitle) {
        this.titulo = newTitle;
    };
    AppComponent.prototype.logout = function () {
        this.deleteCookieFIRMADORID();
        this._keycloak.logout();
    };
    AppComponent.prototype.menuChange = function (event) {
        this.menu = event;
        document.getElementById('_btn').click();
    };
    AppComponent.prototype.clickAviso = function (codigo) {
        var _this = this;
        if (codigo == "FAV") {
            this.router.navigate(['favoritos']);
        }
        else if (codigo == "CED") {
            this.router.navigate(['cedula']);
        }
        this._service.updateAvisos(KeycloakService.getLoggedUser(), codigo).subscribe(function (response) {
            _this.noti = response;
        });
    };
    AppComponent.prototype.generateRandomId = function () {
        // Generar una cadena aleatoria de 16 caracteres
        var randomPart = Math.random().toString(36).substring(2, 18); // Obtiene los primeros 16 caracteres aleatorios
        // Obtener el timestamp actual
        var timestamp = Date.now();
        var firmadorId = randomPart + timestamp.toString();
        return firmadorId;
    };
    AppComponent.prototype.setCookieFIRMADORID = function () {
        var firmadorId = this.generateRandomId();
        //document.cookie = `FIRMADORID=${firmadorId}; path=/; domain=localhost;`; //desa
        document.cookie = "FIRMADORID=" + firmadorId + "; path=/; SameSite=None; Secure;"; //testing
    };
    AppComponent.prototype.deleteCookieFIRMADORID = function () {
        document.cookie = "FIRMADORID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    };
    return AppComponent;
}());
AppComponent = AppComponent_1 = __decorate([
    Component({
        moduleId: module.id,
        selector: 'my-app',
        templateUrl: 'app.component.html'
    }),
    __metadata("design:paramtypes", [Injector,
        HttpClientWrapper,
        Jsonp,
        Router,
        Idle,
        Keepalive])
], AppComponent);
export { AppComponent };
var AppComponent_1;
//# sourceMappingURL=app.component.js.map